import React from 'react';
import MenuPromoModal from '../MenuPromoModal/MenuPromoModal';

const PAGE_ID = 'OnlineMatchPromoModal';

export const ONLINE_MATCH_PROMO_IMAGE_PATH = '/img/other/education_finish_promo.jpg';

/**
 * Приглашение в первый обычный сетевой матч (главное меню): бой с ботами уже
 * позади — пора к живым соперникам. В рейтинг отсюда не зовем: для него нужны
 * четыре фракции, а у новичка их меньше — в рейтинг приглашает следующая
 * модалка, после первого сетевого матча (RankedMatchPromoModal).
 *
 * Когда и кому показывать, решает меню (см. resolveOnlineMatchPromoReason и
 * onlineMatchPromoStorage). Кнопка сама СОБИРАЕТ игроку матч: создает лобби
 * от его имени и ведет в него (onFindOpponents) — дальше сервер подсаживает
 * туда соперников, как в любое лобби в сборе. Искать лобби в списке новичку
 * не приходится.
 *
 * firstOnlineMatchReward — что дадут за задание «сыграть обычный сетевой
 * матч» (см. getOnlineMatchQuestReward): фракция по имени или запасной
 * сундук, если фракция уже открыта; null — награду не обещаем
 */
const OnlineMatchPromoModal = ({reason, firstOnlineMatchReward, onFindOpponents, onClose}) => (
  <MenuPromoModal
    pageId={PAGE_ID}
    reason={reason}
    title={'Пора к живым соперникам!'}
    imagePath={ONLINE_MATCH_PROMO_IMAGE_PATH}
    imageAlt={'Обычный сетевой матч'}
    action={{buttonId: 'find_opponents', label: 'Найти соперников', onClick: onFindOpponents}}
    onClose={onClose}
  >
    <p className={'menu-promo-modal_text'}>
      С ботами ты уже сразился — теперь испытай силы
      {' '}<span className={'text-attention'}>против реальных игроков</span>!
    </p>

    <p className={'menu-promo-modal_text'}>
      Мы соберем тебе <span className={'text-coins'}>обычный матч</span>: рейтинг в нем не
      меняется, так что проигрыш ничего не стоит.
      {firstOnlineMatchReward && (
        <>
          {' '}А за первый матч не на последнем месте получишь награду —
          {/* Имя сундука само начинается со слова «сундук» (см.
              getChestDisplayName), так что подписываем только фракцию */}
          {firstOnlineMatchReward.type === 'faction' ? ' фракцию' : ''}
          {' '}<span className={'text-coins'}>{firstOnlineMatchReward.name}</span>!
        </>
      )}
    </p>
  </MenuPromoModal>
);

export default OnlineMatchPromoModal;
